export class ProcessingStatus {
  entityId!: string;
  entityRevision!: number;
  productFamily!: string;
  erpStatus!: string;
  requestedShipDate!: string;
  requestedEngineeringDate!: string;
  promisedEngineeringDate!: string;
  scheduledShipDate!: string;
  erpOrderNumber!: string;
}
